"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var empty = "undefined";
/**
 * Finds the current global object.
 */
function get() {
    /* istanbul ignore next */
    return typeof window !== empty
        ? window
        : typeof global !== empty
            ? global
            : typeof self !== empty ? self : (0, eval)("this");
}
exports.get = get;
//# sourceMappingURL=index.js.map